import useFetch from '../../hooks/useFetch'
import { useState } from 'react'
import { urlApi } from '../../config'
import Alert from '../Alert'

export default function CompleteLobby({ lobby }) {
  const [alert, setAlert] = useState(true)
  const { loading, responseOk } = useFetch(`${urlApi}/admin/lobbies/complete/${lobby._id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })

  return (
    <Alert
      visible={alert}
      onClose={() => {
        if (!responseOk) {
          setAlert(false)
        } else {
          lobby.completed = true
          setAlert(false)
        }
      }}
      hideButton={loading}
    >
      {
        loading ?
          <>Cargando...</>
          :
          responseOk ?
            <div className='text-green-700 dark:text-emerald-400 font-extrabold text-2xl'>Lobby marcada como completada con exito</div>
            :
            <div className='text-red-600 dark:text-red-400 font-extrabold text-2xl'>Error al marcar como completar la lobby</div>
      }
    </Alert>
  )
}
